module.exports = __webpack_public_path__ + "img/about-hero-bg.010cc8d6.jpg";